import { render, staticRenderFns } from "./WvcButton.vue?vue&type=template&id=1b6fe3e5&scoped=true&"
import script from "./WvcButton.vue?vue&type=script&lang=js&"
export * from "./WvcButton.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./WvcButton.vue?vue&type=style&index=0&id=1b6fe3e5&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1b6fe3e5",
  null
  ,true
)

export default component.exports